import { useLocalization } from "@fluent/react";
import { Chip } from "@mui/material";
import { getStatusChipConfig } from "../helpers/companyBugHelpers";

type Props = {
    status: string | null | undefined;
    showPrefix?: boolean;
};

export const CompanyBugStatusChip = ({ status, showPrefix = false }: Props) => {
    const { l10n } = useLocalization();
    const { l10nId, fallback, color } = getStatusChipConfig(status);
    const value = l10nId ? l10n.getString(l10nId, null, fallback) : fallback;
    const label = showPrefix
        ? `${l10n.getString("bug-report-list-status", null, "Status")}: ${value}`
        : value;

    return <Chip label={label} color={color} size="small" variant="outlined" />;
};
